import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Spinner from '../../core/spinner/Spinner';
import env from '../../../env/env';
// MUI
import { Grid, Typography } from '@mui/material';
// Image file
import logo from '../../../images/treeimg.png';
// CSS file
import "./Registration.css";


export default function Activation() {
    const {username_to_activate} = useParams();
    const [message, setMessage] = useState("");
    const [done, setDone] = useState(false);
    const [isActive, setIsActive] = useState(null);
    const [requested, setRequested] = useState(false);

    useEffect(() => {
        if (username_to_activate) {
            axios.get(env.BACKEND_API_URL + '/api/accounts/activate/', { params: { username: username_to_activate } })
                .then((res) => {
                    if (res.status !== 200) {
                        throw new Error(res.response.data.detail);
                    }
                    else if (res.data.is_active) {
                        setMessage(res.data.detail);
                        setDone(true);
                        setIsActive(true);
                    }

                    else {
                        setMessage(res.data.detail);
                        setIsActive(false);
                        setDone(true);
                    }
                    
                })
                .catch((error) => {
                    setMessage(String(error))
                });
                
        } else {
            setMessage("The link is not valid.")
            setDone(true);
        }
             
    // eslint-disable-next-line
    }, [])

    const handleActivate = () => {
        setDone(false);
        axios.post(env.BACKEND_API_URL + '/api/accounts/activate/', {username: username_to_activate})
            .then((res) => {
                setMessage(res.data.detail);
                setIsActive(true); // Assume activation succeeded
            })
            .catch((error) => {
                setMessage(String(error));
            })
            .finally(() => {
                setDone(true);
                setRequested(true);
            });
    };

    return (
        <div>
            <div className="hp--container">
                <div className="hp--title">
                    <div className="hp--title-text">
                        <h2><span className="title--1">O</span><span className="title--2">RCH</span><span className="title--3">ESTRATION</span></h2>
                        <h2><span className="title--1">A</span><span className="title--3">NALYSIS &</span></h2>
                        <h2><span className="title--1">R</span><span className="title--3">ESEARCH</span></h2>
                        <h2><span className="title--1">D</span><span className="title--3">ATABASE</span></h2>
                    </div>
                    <img src={logo} alt="orchard logo" />
                </div>
                <br />
                <Grid
                    container
                    spacing={0}
                    direction="column"
                    alignItems="center"
                    justifyContent="center"
                    >
                        {!done ? (
                            <Spinner />
                        ) : (
                            <Grid item xs={3} style={{textAlign: "center"}}>
                                    <Typography align="center" variant="h5">
                                        <b>{message}</b>
                                    </Typography>
                                    {isActive === false && !requested && (
                                        <button onClick={handleActivate} style={{marginTop: "20px", fontWeight: "bold"}}>
                                            Activate Account
                                        </button>
                                    )}
                            </Grid>
                        )}
                </Grid>
            </div>
        </div>
    )
}